<template>
  <div class="mahtas-mark" :class="{ compact, 'is-dark': dark }">
    <div class="mahtas-marks">
      <div class="mahtas-crest">
        <img src="@/assets/KKM/Logo_KKM.png" alt="Kementerian Kesihatan Malaysia" />
      </div>
      <span class="mahtas-rule" aria-hidden="true"></span>
      <div class="mahtas-qmed">
        <img src="@/assets/Qmed-logo.png" alt="Qmed Asia" />
      </div>
    </div>
    <p class="mahtas-primary">Co-developed with the Ministry of Health Malaysia</p>
    <p v-if="!compact" class="mahtas-secondary">MaHTAS | Qmed Asia</p>
    <p v-if="!compact" class="mahtas-secondary">Free for public healthcare workers (KKM) nationwide.</p>
  </div>
</template>

<script>
export default {
  name: 'MahtasMark',
  props: {
    compact: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.mahtas-mark {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 420px;
  margin: 0 auto;
}

.mahtas-marks {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 0.75rem;
  background: transparent;
}

.mahtas-crest img {
  display: block;
  height: 52px;
  width: auto;
  max-width: 160px;
  object-fit: contain;
}

.mahtas-qmed img {
  display: block;
  height: 26px;
  width: auto;
  max-width: 140px;
  object-fit: contain;
}

.mahtas-rule {
  width: 1px;
  height: 28px;
  background: #e4e7ec;
}

.mahtas-primary {
  margin: 0;
  color: #231f20;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.4;
}

.mahtas-secondary {
  margin: 0.2rem 0 0;
  color: #7b8290;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 1.45;
}

.mahtas-mark.is-dark .mahtas-primary {
  color: #ececf1;
}

.mahtas-mark.is-dark .mahtas-secondary {
  color: #9fa6b1;
}

@media (max-width: 640px) {
  .mahtas-marks {
    gap: 10px;
    margin-bottom: 0.4rem;
  }

  .mahtas-crest img {
    height: 36px;
    max-width: 110px;
  }

  .mahtas-qmed img {
    height: 18px;
    max-width: 100px;
  }

  .mahtas-rule {
    height: 20px;
  }

  .mahtas-primary {
    font-size: 11.5px;
  }

  .mahtas-secondary {
    display: none;
  }
}
</style>
